window.addEventListener('load', () => {
  const loginPopup = document.getElementById('maksimer-login-popup');
  const header = document.getElementById('theme-header');
  const wpadminbar = document.getElementById('wpadminbar');

  if (loginPopup) {
    const closeLogin = loginPopup.querySelector('.btn--close-login');
    const waitTime = (+loginPopup.dataset.time_on || 5) * 1000;

    closeLogin.addEventListener('click', () => {
      loginPopup.classList.remove('show');
    });

    setTimeout(() => {
      loginPopup.classList.add('show');
    }, waitTime);

    // eslint-disable-next-line no-inner-declarations
    function calculateStickyDropdownTop() {
      let top = 0;

      top += header ? header.offsetHeight : 0;

      top += wpadminbar ? wpadminbar.offsetHeight : 0;

      loginPopup.style.top = `${top}px`;
    }

    calculateStickyDropdownTop(loginPopup);

    window.addEventListener('scroll', calculateStickyDropdownTop);
  }
});
